module.exports = __webpack_public_path__ + "static/media/PHP_example.111e2f9a.zip";